import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b79f472a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile" }
const _hoisted_2 = { class: "option" }
const _hoisted_3 = { class: "option" }
const _hoisted_4 = { class: "option" }
const _hoisted_5 = {
  key: 0,
  class: "mask"
}

import api from '@/api/fyApi';
import i18, { State as I18State } from '@/store/i18';
import user, { State } from '@/store/user';
import { computed, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import DEmail from './DEmail.vue';
import DNickname from './DNickname.vue';
import DPassword from './DPassword.vue';
import DQa from './DQa.vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const i18Data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18Data.value.texts[i18Data.value.lang.list[i18Data.value.lang.now]].login)
const route = useRoute()
const data = computed<State>(() => store.state[user.name]);
const avatars = ref<AvatarOption[]>([]);
const state = reactive({
    avatarListVisible: false,
    nicknameVisible: false,
    passwordVisible: false,
    emailVisible: false,
    qaVisible: false,
})

const dialogVisible = computed(() => state.nicknameVisible || state.passwordVisible || state.emailVisible || state.qaVisible)
onMounted(() => {
    if (route.query.pwd == '1') {
        state.passwordVisible = true
    }
})
async function showAvatarList() {
    if (avatars.value.length == 0) {
        avatars.value = await api.getAvatarList()
    }
    state.avatarListVisible = true
    document.onmousedown = function () {
        document.onmousedown = null;
        state.avatarListVisible = false;
    }
}
async function onChangeAvatar(item: AvatarOption) {
    user.updateAvatar(store, item);
    document.onmousedown = null;
    state.avatarListVisible = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_unref(lang).set_email), 1),
      _createElementVNode("span", null, _toDisplayString(_unref(data).info?.email || _unref(lang).set_undo), 1),
      _createElementVNode("a", {
        class: "edit",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).emailVisible = true))
      }, "[" + _toDisplayString(_unref(lang).do_set) + "]", 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_unref(lang).set_password), 1),
      _createElementVNode("span", null, _toDisplayString(_unref(data).info?.vpassword ? _unref(lang).set_done : _unref(lang).set_undo), 1),
      _createElementVNode("a", {
        class: "edit",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).passwordVisible = true))
      }, "[" + _toDisplayString(_unref(lang).do_set) + "]", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", null, _toDisplayString(_unref(lang).set_qa), 1),
      _createElementVNode("span", null, _toDisplayString(_unref(data).info?.vsq ? _unref(lang).set_done : _unref(lang).set_undo), 1),
      _createElementVNode("a", {
        class: "edit",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).qaVisible = true))
      }, "[" + _toDisplayString(_unref(lang).do_set) + "]", 1)
    ]),
    (_unref(dialogVisible))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5))
      : _createCommentVNode("", true),
    (_unref(state).nicknameVisible)
      ? (_openBlock(), _createBlock(DNickname, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_unref(state).nicknameVisible = false))
        }))
      : _createCommentVNode("", true),
    (_unref(state).passwordVisible)
      ? (_openBlock(), _createBlock(DPassword, {
          key: 2,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(state).passwordVisible = false))
        }))
      : _createCommentVNode("", true),
    (_unref(state).emailVisible)
      ? (_openBlock(), _createBlock(DEmail, {
          key: 3,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_unref(state).emailVisible = false))
        }))
      : _createCommentVNode("", true),
    (_unref(state).qaVisible)
      ? (_openBlock(), _createBlock(DQa, {
          key: 4,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_unref(state).qaVisible = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})